import { createSelector } from '@reduxjs/toolkit';
import { SelectItem } from 'vet-bones/utils/select';

import { namedGraphsByModelSelector } from 'src/selectors/namedGraphsByModel';
import { ReduxState } from 'src/store/types';
import { DEFAULT_MODEL } from 'src/templates/queries/iris';
import { stringToSelectItem } from 'src/utils/select/stringToSelectItem';

export type ModelSelectItem = SelectItem & {
  namedGraph?: string;
};

const defaultModelItems = [{ ...stringToSelectItem(DEFAULT_MODEL) }];

export const modelItemsSelector = (databaseId: string) =>
  createSelector(
    (state: ReduxState) =>
      databaseId
        ? state.databases.databasesById?.[databaseId]?.models || []
        : [],
    namedGraphsByModelSelector(databaseId),
    (models, namedGraphsByModel): ModelSelectItem[] => {
      return models && models.length
        ? models.map(stringToSelectItem).map((model) => ({
            ...model,
            namedGraph: namedGraphsByModel?.[model.value]?.[0],
          }))
        : defaultModelItems;
    }
  );
